<template>
  <div class="page">
    <h3>광고캐시백 조회 - 수당 조회</h3>

    <div class="toolbar">
      <!-- 20003: 센터/이름 개별 검색 + 검색 팝업. role customer 는 내정보 고정·비활성·검색버튼 숨김 -->
      <label>센터</label>
      <!-- 센터, 이름 조회 입력받기 프로젝트 -->
      <input v-model="centerName" type="text" class="narrow" :disabled="isCustomer" @keyup.enter="reload" />
      <button v-if="!isCustomer" class="ghost sm" @click="centerDlgOpen=true">검색</button>
      <button v-if="!isCustomer" class="ghost sm" @click="centerName=''">비우기</button>
      <label>이름</label>
      <!-- 센터, 이름 조회 입력받기 프로젝트 -->
      <input v-model="custName" type="text" class="narrow" :disabled="isCustomer" @input="custLoginId=''" @keyup.enter="reload" />
      <button v-if="!isCustomer" class="ghost sm" @click="memberDlgOpen=true">검색</button>
      <button v-if="!isCustomer" class="ghost sm" @click="custName=''; custLoginId=''">비우기</button>
      <label>조회기간</label>
      <input v-model="fromDt" type="date" />
      <span class="dash">~</span>
      <input v-model="toDt" type="date" />
      <button @click="reload">조회</button>
      <span class="spacer"></span>
      <button class="ghost" @click="openPosition">후원 조직도</button>
      <button class="ghost" @click="referralOpen=true">추천 조직도</button>
      <button v-if="canViewAll" class="ghost" @click="referralAdminOpen=true">추천 조직도 (관리자)</button>
      <!-- 개선2_61: 멤버쉽 캐시백 지도(관리자) -->
      <button v-if="canViewAll" class="ghost" @click="memTreeOpen=true">멤버쉽 캐시백 지도(관리자)</button>
      <button class="ghost" @click="openDownload">다운로드</button>
    </div>
    <!-- 23002: 다운로드 버튼 밑 한 줄, 맨 우측에 수당지급 다운로드 버튼 (admin/staff 만 표시) -->
    <div v-if="canViewAll" class="toolbar toolbar2">
      <span class="spacer"></span>
      <button class="ghost" @click="openPayoutDownload">수당지급 다운로드</button>
    </div>
    <p v-if="dlBlockMsg" class="dl-block-msg">{{ dlBlockMsg }}</p>

    <!-- 20003: 실 지급 금액 표 (지급 이력 GRE_PAY_HIST). 원천징수 공제 최종지급액 / 지급일=수당계산일+8일 -->
    <h4 class="sub">실 지급 금액</h4>
    <div class="table-scroll">
      <table class="grid payhist">
        <thead>
          <tr>
            <th>센터명</th><th>로그인ID</th><th>이름</th><th>수당 계산일</th><th>최종 지급액</th><th>지급일</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(h, i) in payHistList" :key="'ph'+i">
            <td>{{ h.centerName }}</td>
            <td>{{ h.loginId }}</td>
            <td>{{ h.name }}</td>
            <td>{{ h.calcDt }}</td>
            <td class="num">{{ fmt(h.payAmt) }}</td>
            <td>{{ h.payDt }}</td>
          </tr>
          <tr v-if="payHistList.length===0"><td colspan="6" class="empty">데이터가 없습니다.</td></tr>
        </tbody>
      </table>
    </div>
    <Paging :page="payHistPage" :size="payHistSize" :total-count="payHistTotal"
            :total-pages="payHistTotalPages" @change-page="onPayHistPage" @change-size="onPayHistSize" />

    <!-- S12 필수항목 결산 요약표 (스펙234_개선_18: 화면 표기는 '일별 수당') -->
    <h4 class="sub">일별 수당</h4>
    <div class="table-scroll">
      <table class="grid closing">
        <thead>
          <tr>
            <!-- 개선2_61: '업체 수수료' 항목은 화면에서만 감춤(데이터 유지) -->
            <th>수당 계산일</th><th>매출</th><th>VAT 차감</th><th>수당 계산원금</th>
            <th>최종수당</th><th>최종지급액</th><th>원천징수</th><th>원천징수차감</th>
          </tr>
        </thead>
        <tbody>
          <!-- 1행 : 범위 총합(검색조건 반영) -->
          <tr v-if="closingList.length" class="total-row">
            <td>{{ closingTotal.range }}</td>
            <td class="num">{{ fmt(closingTotal.sales) }}</td>
            <td class="num">{{ fmt(closingTotal.exceptVat) }}</td>
            <td class="num">{{ fmt(closingTotal.calcPrincipal) }}</td>
            <td class="num">{{ fmt(closingTotal.finalCost) }}</td>
            <td class="num">{{ fmt(closingTotal.finalSal) }}</td>
            <td class="num">{{ fmt(closingTotal.tax) }}</td>
            <td class="num">{{ fmt(closingTotal.exceptTax) }}</td>
          </tr>
          <!-- 2행부터 : 개별 마감일 -->
          <tr v-for="c in closingList" :key="c.dt">
            <td>{{ c.dt }}</td>
            <td class="num">{{ fmt(c.sales) }}</td>
            <td class="num">{{ fmt(c.exceptVat) }}</td>
            <td class="num">{{ fmt(c.calcPrincipal) }}</td>
            <td class="num">{{ fmt(c.finalCost) }}</td>
            <td class="num">{{ fmt(c.finalSal) }}</td>
            <td class="num">{{ fmt(c.tax) }}</td>
            <td class="num">{{ fmt(c.exceptTax) }}</td>
          </tr>
          <tr v-if="closingList.length===0"><td colspan="8" class="empty">데이터가 없습니다.</td></tr>
        </tbody>
      </table>
    </div>

    <!-- 수당 상세표 : 가로가 길면 가로 스크롤바 생성 -->
    <h4 class="sub">수당 상세</h4>
    <div class="table-scroll">
      <table class="grid">
        <thead>
          <tr>
            <th>로그인ID</th><th>이름</th><th>직급</th><th>수당 계산일</th>
            <th>결제액</th><th>반품액</th><th>반품철회액</th><th>전체취소액</th>
            <th>멤버쉽</th><th>팀</th><th>추천매칭</th><th>리드쉽공유</th><th>센터지원</th>
            <th>수당</th><th>반품PV</th><th>반품철회PV</th><th>최종지급액</th><th>통산수당</th><th>수당한도</th><th>원천징수</th><th>원천징수차감</th>
          </tr>
        </thead>
        <tbody>
          <!-- 1행 : 총합(검색조건 반영). 스펙51: 총합의 통산수당·수당한도 칸은 빈칸. -->
          <tr v-if="list.length" class="total-row">
            <td>합계</td><td></td><td></td><td></td>
            <td class="num">{{ fmt(detailTotal.purchaseAmt) }}</td>
            <td class="num">{{ fmt(detailTotal.refundAmt) }}</td>
            <td class="num">{{ fmt(detailTotal.refundCancelAmt) }}</td>
            <td class="num">{{ fmt(detailTotal.allRetAmt) }}</td>
            <td class="num">{{ fmt(detailTotal.membershipCb) }}</td>
            <td class="num">{{ fmt(detailTotal.teamCb) }}</td>
            <td class="num">{{ fmt(detailTotal.matchingCb) }}</td>
            <td class="num">{{ fmt(detailTotal.leadershipCb) }}</td>
            <td class="num">{{ fmt(detailTotal.centerCb) }}</td>
            <td class="num">{{ fmt(detailTotal.sudang) }}</td>
            <td class="num">{{ fmt(detailTotal.finalRefundPt) }}</td>
            <td class="num">{{ fmt(detailTotal.finalRefundCancelPt) }}</td>
            <td class="num">{{ fmt(detailTotal.finalPayout) }}</td>
            <td></td>
            <td></td>
            <td class="num">{{ fmt(detailTotal.tax) }}</td>
            <td class="num">{{ fmt(detailTotal.exceptTax) }}</td>
          </tr>
          <!-- 2행부터 : 노드별. 개별행은 모든 칸 값 표시(빈칸 없음). -->
          <tr v-for="row in list" :key="row.id">
            <td>{{ row.loginId }}</td>
            <td>{{ row.nodeName || row.name }}</td>
            <td><span class="rank">{{ row.rankName || '그린스타' }}</span></td>
            <td>{{ row.calcDt }}</td>
            <td class="num">{{ fmt(row.purchaseAmt) }}</td>
            <td class="num">{{ fmt(row.refundAmt) }}</td>
            <td class="num">{{ fmt(row.refundCancelAmt) }}</td>
            <td class="num">{{ fmt(row.allRetAmt) }}</td>
            <td class="num">{{ fmt(row.membershipCb) }}</td>
            <td class="num">{{ fmt(row.teamCb) }}</td>
            <td class="num">{{ fmt(row.matchingCb) }}</td>
            <td class="num">{{ fmt(row.leadershipCb) }}</td>
            <td class="num">{{ fmt(row.centerCb) }}</td>
            <td class="num">{{ fmt(row.sudang) }}</td>
            <td class="num pv-cell">
              {{ fmt(row.finalRefundPt) }}
              <button v-if="Number(row.finalRefundPt) > 0 && isAdmin" class="basis-btn" @click="openBasis(row)">발생근거</button>
            </td>
            <td class="num pv-cell">
              {{ fmt(row.finalRefundCancelPt) }}
              <button v-if="Number(row.finalRefundCancelPt) > 0 && isAdmin" class="basis-btn" @click="openBasis(row)">발생근거</button>
            </td>
            <td class="num total-cell">{{ fmt(row.finalPayout) }}</td>
            <td class="num">{{ fmt(row.totalPt) }}</td>
            <td class="num">{{ fmt(row.limitAmt) }}</td>
            <td class="num">{{ fmt(tax(row.finalPayout)) }}</td>
            <td class="num">{{ fmt(exceptTax(row.finalPayout)) }}</td>
          </tr>
          <tr v-if="list.length===0"><td colspan="21" class="empty">데이터가 없습니다.</td></tr>
        </tbody>
      </table>
    </div>

    <Paging :page="page" :size="size" :total-count="totalCount" :total-pages="totalPages"
            @change-page="onPage" @change-size="onSize" />

    <!-- 다운로드 팝업 : 시작일/종료일 지정 (기본 오늘) -->
    <div v-if="downloadOpen" class="modal-mask" @click.self="downloadOpen=false">
      <div class="modal">
        <h4>엑셀 다운로드 기간 지정</h4>
        <div class="dl-row"><label>시작일</label><input v-model="startDt" type="date" /></div>
        <div class="dl-row"><label>종료일</label><input v-model="endDt" type="date" /></div>
        <p v-if="dlError" class="dl-error">{{ dlError }}</p>
        <div class="modal-btns">
          <button class="ghost" @click="downloadOpen=false">취소</button>
          <button class="primary" :disabled="dlBusy" @click="doDownload">다운로드</button>
        </div>
      </div>
    </div>

    <!-- 23002: 수당지급 다운로드 팝업 : 출금일 캘린더(기본 오늘) -->
    <div v-if="payoutOpen" class="modal-mask" @click.self="payoutOpen=false">
      <div class="modal">
        <div class="dl-row"><label>지급일</label><input v-model="payoutDate" type="date" /></div>
        <p v-if="payoutError" class="dl-error">{{ payoutError }}</p>
        <div class="modal-btns">
          <button class="ghost" @click="payoutOpen=false">취소</button>
          <button class="primary" :disabled="payoutBusy" @click="doPayoutDownload">다운로드</button>
        </div>
      </div>
    </div>

    <!-- 스펙56: 반품PV/반품철회PV 발생근거 팝업 -->
    <div v-if="basisOpen" class="modal-mask" @click.self="basisOpen=false">
      <div class="modal basis-modal">
        <div class="basis-head">
          <h4>발생 근거</h4>
          <button class="ghost" @click="basisOpen=false">닫기</button>
        </div>
        <div class="basis-pv">
          <div><b>반환PV</b> : <span class="num">{{ fmt(basis.finalRefundPt) }}</span>
            <span class="basis-range" v-if="basis.retSt">— 반환된 수당 기록 구간 {{ basis.retSt }} ~ {{ basis.retEd }} 사이의 최종수당 합</span>
          </div>
          <div><b>반환철회PV</b> : <span class="num">{{ fmt(basis.finalRefundCancelPt) }}</span>
            <span class="basis-range" v-if="basis.retCancelSt">— 반환철회된 수당 기록 구간 {{ basis.retCancelSt }} ~ {{ basis.retCancelEd }} 사이의 최종수당 합</span>
          </div>
        </div>
        <p class="basis-note">
          배치일({{ basisDt }})에 반품한 아래 주문들의 PV반환시작일/종료일(및 PV반환철회 시작일/종료일)을 종합하여,
          가장 이른 시작일 ~ 가장 늦은 종료일 구간이 반환PV/반환철회PV의 산정 구간으로 결정되었습니다.
        </p>
        <div class="basis-table-wrap">
          <table class="grid basis-grid">
            <thead>
              <tr>
                <th>주문번호</th><th>업무</th><th>결제액</th><th>반품액</th><th>반품철회액</th><th>전체취소액</th>
                <th>구매일</th><th>PV반환시작일</th><th>PV반환종료일</th><th>PV반환철회시작일</th><th>PV반환철회종료일</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(r, i) in basisRows" :key="i">
                <td>{{ r.orderNo }}</td>
                <td class="center">{{ workLabel(r.work) }}</td>
                <td class="num">{{ fmt(r.amount) }}</td>
                <td class="num">{{ fmt(r.refundAmt) }}</td>
                <td class="num">{{ fmt(r.refundCancelAmt) }}</td>
                <td class="num">{{ fmt(r.allRetAmt) }}</td>
                <td class="center">{{ r.buyDt }}</td>
                <td class="center">{{ r.retRangeSt || '-' }}</td>
                <td class="center">{{ r.retRangeEd || '-' }}</td>
                <td class="center">{{ r.retCancelRangeSt || '-' }}</td>
                <td class="center">{{ r.retCancelRangeEd || '-' }}</td>
              </tr>
              <tr v-if="basisRows.length === 0"><td colspan="11" class="empty">배치일에 반품한 항목이 없습니다.</td></tr>
            </tbody>
          </table>
        </div>
        <p v-if="basisErr" class="dl-error">{{ basisErr }}</p>
      </div>
    </div>

    <!-- 스펙24: 후원 조직도 - 후원계보 빌딩 그래픽 팝업 -->
    <PositionTreeDialog v-if="positionOpen" @close="positionOpen=false" />
    <!-- 개선2_61: 멤버쉽 캐시백 지도(관리자) -->
    <PositionTreeDialog v-if="memTreeOpen" :membership="true" @close="memTreeOpen=false" />
    <!-- 스펙207: 추천 조직도 - 추천계보 빌딩 그래픽 팝업 -->
    <ReferralTreeDialog v-if="referralOpen" @close="referralOpen=false" />
    <!-- 스펙211: 추천 조직도(관리자) - 직급 아래 일캐시백 5% 표시 (staff/admin 전용) -->
    <ReferralTreeDialog v-if="referralAdminOpen" :admin="true" @close="referralAdminOpen=false" />
    <!-- 20003: 수당 조회 전용 센터 검색 / 회원 검색 팝업 (별도 컴포넌트, 스펙 컬럼) -->
    <SettlementCenterSearchDialog v-if="centerDlgOpen" @select="onPickCenter" @close="centerDlgOpen=false" />
    <SettlementMemberSearchDialog v-if="memberDlgOpen" @select="onPickMember" @close="memberDlgOpen=false" />
  </div>
</template>

<script>
import * as XLSX from 'xlsx';
import XLSXStyle from 'xlsx-js-style';   // 23002: 셀 정렬 스타일 지원(쓰기 시 cell.s 반영)
import api from '../api';
import { getAuth, canViewAll } from '../store/auth';
import Paging from '../components/Paging.vue';
import PositionTreeDialog from '../components/PositionTreeDialog.vue';
import ReferralTreeDialog from '../components/ReferralTreeDialog.vue';
import SettlementCenterSearchDialog from '../components/SettlementCenterSearchDialog.vue';
import SettlementMemberSearchDialog from '../components/SettlementMemberSearchDialog.vue';

function today() {
  const d = new Date();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return d.getFullYear() + '-' + m + '-' + day;
}

export default {
  name: 'PointInquiry',
  components: { Paging, PositionTreeDialog, ReferralTreeDialog, SettlementCenterSearchDialog, SettlementMemberSearchDialog },
  data() {
    return {
      list: [], closingList: [],
      detailTotal: {},
      page: 1, size: 10, totalCount: 0, totalPages: 0,
      // 20003: 실 지급 금액(지급 이력) 표 - 독립 페이징
      payHistList: [], payHistPage: 1, payHistSize: 10, payHistTotal: 0, payHistTotalPages: 0,
      fromDt: '', toDt: '', custName: '', custLoginId: '',
      // 20003: 센터 검색어 + 센터/회원 검색 팝업 상태
      centerName: '', centerDlgOpen: false, memberDlgOpen: false,
      downloadOpen: false, startDt: today(), endDt: today(), dlBusy: false, dlError: '',
      dlBlockMsg: '',
      // 23002: 수당지급 다운로드(출금일 팝업)
      payoutOpen: false, payoutDate: today(), payoutBusy: false, payoutError: '',
      positionOpen: false, memTreeOpen: false,
      referralOpen: false,
      referralAdminOpen: false,
      canViewAll: canViewAll(),
      // 스펙56: 발생근거 팝업
      basisOpen: false, basis: {}, basisRows: [], basisDt: '', basisErr: '',
      // v112: 발생근거 버튼은 admin 권한만 표시 (customer·staff 미표시)
      isCustomer: getAuth().role === 'customer',
      isAdmin: getAuth().role === 'admin'
    };
  },
  computed: {
    // 결산 요약표 1행(범위 총합)
    closingTotal() {
      const t = { range: '-', sales: 0, exceptVat: 0, calcPrincipal: 0, fee: 0,
                  finalCost: 0, finalSal: 0, tax: 0, exceptTax: 0 };
      if (!this.closingList.length) return t;
      let min = null, max = null;
      for (const c of this.closingList) {
        t.sales += Number(c.sales || 0);
        t.exceptVat += Number(c.exceptVat || 0);
        t.calcPrincipal += Number(c.calcPrincipal || 0);
        t.fee += Number(c.fee || 0);
        t.finalCost += Number(c.finalCost || 0);
        t.finalSal += Number(c.finalSal || 0);
        t.tax += Number(c.tax || 0);
        t.exceptTax += Number(c.exceptTax || 0);
        if (min === null || c.dt < min) min = c.dt;
        if (max === null || c.dt > max) max = c.dt;
      }
      t.range = (min === max) ? min : (min + ' ~ ' + max);
      return t;
    }
  },
  async created() {
    try {
      const latest = await api.latest();
      if (latest.data.pointDt) { this.fromDt = latest.data.pointDt; this.toDt = latest.data.pointDt; }
    } catch (e) { /* noop */ }
    // 20003: role customer 는 센터명/이름을 내 정보로 고정 표시(비활성). staff/admin 은 빈칸.
    if (this.isCustomer) {
      try {
        const meRes = await api.me();
        const me = meRes.data || {};
        this.centerName = me.centerName || '';
        this.custName = me.name || '';
      } catch (e) { /* noop */ }
    }
    this.reload();
  },
  methods: {
    // 스펙24: 후원 조직도 팝업 열기. 초기 진입은 빈칸(자동조회 없음),
    //         팝업 상단의 id/단수/좌우 라디오+검색으로 조회한다.
    openPosition() {
      this.positionOpen = true;
    },
    workLabel(w) { return ({ P: '결제', R: '반품', RC: '반품철회', ALLR: '전체취소' })[w] || (w || '결제'); },
    // 스펙56: 반품PV/반품철회PV 발생근거 팝업 열기 (PV값+결정구간+배치일 반품 항목)
    async openBasis(row) {
      this.basisOpen = true; this.basisErr = '';
      this.basis = {}; this.basisRows = []; this.basisDt = row.calcDt;
      try {
        const res = await api.refundBasis(row.customerId, row.calcDt);
        const d = res.data || {};
        this.basis = d;
        this.basisRows = d.rows || [];
      } catch (e) { this.basisErr = e.message; }
    },
    async load() {
      //센터, 이름 조회 입력받기 프로젝트
      const params = { page: this.page, size: this.size, custLoginId: this.custLoginId, custName: this.custName.trim(),
                       centerName: this.centerName.trim(), startDt: this.fromDt, endDt: this.toDt };
      const res = await api.points(params);
      this.list = res.data.list;
      this.totalCount = res.data.totalCount;
      this.totalPages = res.data.totalPages;
      // S12 필수항목 결산 요약(같은 날짜 범위 + 고객명 필터). 총합은 검색조건 반영.
      try {
        //센터, 이름 조회 입력받기 프로젝트
        const cr = await api.closing({ startDt: this.fromDt, endDt: this.toDt, custLoginId: this.custLoginId, custName: this.custName.trim(),
          centerName: this.centerName.trim()
         });
        this.closingList = cr.data || [];
      } catch (e) { this.closingList = []; }
      // 스펙33: 정산 상세표 총합행(검색조건 반영)
      try {
        //센터, 이름 조회 입력받기 프로젝트
        const tr = await api.pointsTotals({ custLoginId: this.custLoginId, custName: this.custName.trim(), centerName: this.centerName.trim(),
          startDt: this.fromDt, endDt: this.toDt });
        this.detailTotal = tr.data || {};
      } catch (e) { this.detailTotal = {}; }
      // 20003: 실 지급 금액(지급 이력) 표
      this.loadPayHist();
    },
    // 20003: 실 지급 금액(GRE_PAY_HIST) 조회. customer 는 서버에서 본인 것만 반환.
    async loadPayHist() {
      try {
        //센터, 이름 조회 입력받기 프로젝트
        const res = await api.payHist({
          page: this.payHistPage, size: this.payHistSize,
          centerName: this.centerName, custLoginId: this.custLoginId, custName: this.custName.trim(),
          startDate: this.fromDt, endDate: this.toDt
        });
        const d = res.data || {};
        this.payHistList = d.rows || [];
        this.payHistTotal = d.total || 0;
        this.payHistTotalPages = this.payHistSize > 0 ? Math.ceil((d.total || 0) / this.payHistSize) : 0;
      } catch (e) { this.payHistList = []; this.payHistTotal = 0; this.payHistTotalPages = 0; }
    },
    onPayHistPage(p) { this.payHistPage = p; this.loadPayHist(); },
    onPayHistSize(s) { this.payHistSize = s; this.payHistPage = 1; this.loadPayHist(); },
    // 20003: 센터 검색 팝업에서 센터 선택 → 센터명만 채움(조회는 바로 실행하지 않음)
    onPickCenter(c) { this.centerName = (c && c.centerName) || ''; this.centerDlgOpen = false; },
    // 회원 검색 팝업에서 회원 선택 → 이름을 채워 표시(이름 LIKE 검색). 이름이 없으면 로그인ID 대체. 조회는 바로 실행하지 않음.
    onPickMember(m) { this.custName = (m && m.name) || ''; this.custLoginId = (m && m.loginId) || ''; this.memberDlgOpen = false; },
    reload() {
      if (this.fromDt && this.toDt && this.fromDt > this.toDt) {
        this.dlBlockMsg = '시작일이 종료일보다 늦을 수 없습니다.';
        return;
      }
      this.dlBlockMsg = '';
      this.page = 1;
      this.payHistPage = 1;
      this.load();
    },
    onPage(p) { this.page = p; this.load(); },
    onSize(s) { this.size = s; this.page = 1; this.load(); },
    fmt(v) { return v == null ? '0' : Number(v).toLocaleString(); },
    // 스펙105: 노드 원천징수 = 0방향 절사(최종수당*0.033) (음수는 올림). 원천징수차감 = 최종수당 - 원천징수
    tax(fp) { return Math.trunc(Number(fp || 0) * 0.033); },
    exceptTax(fp) { return Number(fp || 0) - Math.trunc(Number(fp || 0) * 0.033); },
    openDownload() {
      // 스펙203: 다운로드 전 사용자명 지정 필수 요건 제거 → 사용자명 없이도 팝업 진입 허용
      this.dlBlockMsg = '';
      this.startDt = today(); this.endDt = today(); this.dlError = '';
      this.downloadOpen = true;
    },
    async doDownload() {
      this.dlError = '';
      if (this.startDt > this.endDt) { this.dlError = '시작일이 종료일보다 늦을 수 없습니다.'; return; }
      this.dlBusy = true;
      try {
        const res = await api.pointsExport({ startDt: this.startDt, endDt: this.endDt, custLoginId: this.custLoginId });
        // 30001: 서버가 '수당 0 초과' 건만 반환. 주민번호/휴대전화는 '직급'과 '수당 계산일' 사이에 표시.
        const rows = (res.data || []).map(r => ({
          로그인ID: r.loginId, 이름: r.nodeName || r.name,
          직급: r.rankName || '그린스타',
          주민번호: r.jumin || '', 휴대전화: r.phone || '',
          '수당 계산일': r.calcDt,
          결제액: r.purchaseAmt, 반품액: r.refundAmt, 반품철회액: r.refundCancelAmt, 전체취소액: r.allRetAmt,
          멤버쉽: r.membershipCb, 팀: r.teamCb, 추천매칭: r.matchingCb, 리드쉽공유: r.leadershipCb, 센터지원: r.centerCb,
          수당: r.sudang, 반품PV: r.finalRefundPt, 반품철회PV: r.finalRefundCancelPt,
          최종지급액: r.finalPayout, 통산수당: r.totalPt, 수당한도: r.limitAmt,
          원천징수: this.tax(r.finalPayout), 원천징수차감: this.exceptTax(r.finalPayout)
        }));
        // 30001: 폰트 모두 10(주민번호·휴대전화만 9). 열너비 모두 9(로그인ID 11 / 주민번호 12 / 휴대전화 11). 폰트 지정 위해 xlsx-js-style 사용.
        const ws = XLSXStyle.utils.json_to_sheet(rows);
        const LOGIN = 0, JUMIN = 3, PHONE = 4;   // 0:로그인ID 1:이름 2:직급 3:주민번호 4:휴대전화 5:수당계산일 ...
        const colCount = 23;
        const cols = [];
        for (let i = 0; i < colCount; i++) {
          let w = 9;
          if (i === LOGIN) w = 11; else if (i === JUMIN) w = 12; else if (i === PHONE) w = 11;
          cols.push({ wch: w });
        }
        ws['!cols'] = cols;
        const ref = XLSXStyle.utils.decode_range(ws['!ref']);
        for (let R = ref.s.r; R <= ref.e.r; R++) {
          for (let C = ref.s.c; C <= ref.e.c; C++) {
            const addr = XLSXStyle.utils.encode_cell({ r: R, c: C });
            const cell = ws[addr];
            if (!cell) continue;
            cell.s = cell.s || {};
            cell.s.font = Object.assign({}, cell.s.font, { sz: (C === JUMIN || C === PHONE) ? 9 : 10 });
          }
        }
        const wb = XLSXStyle.utils.book_new();
        XLSXStyle.utils.book_append_sheet(wb, ws, '포인트조회');
        XLSXStyle.writeFile(wb, `point_${this.startDt}_${this.endDt}.xlsx`);
        this.downloadOpen = false;
      } catch (e) {
        this.dlError = e.message;
      } finally {
        this.dlBusy = false;
      }
    },
    // 23002: 수당지급 다운로드 팝업 열기(출금일 기본 오늘)
    openPayoutDownload() {
      this.payoutDate = today();
      this.payoutError = '';
      this.payoutOpen = true;
    },
    // 23002: 출금일(=캘린더-8일) 기준 수당지급 엑셀 다운로드
    async doPayoutDownload() {
      this.payoutError = '';
      if (!this.payoutDate) { this.payoutError = '출금일을 지정하세요.'; return; }
      this.payoutBusy = true;
      try {
        const res = await api.payoutExport(this.payoutDate);
        const data = res.data || [];
        if (data.length === 0) { this.payoutError = '해당 출금일에 지급할 데이터가 없습니다.'; return; }
        const td = today();
        // 지급일 = 선택한 지급일(캘린더 날짜). except_tax 는 그 8일 전(수당계산일)으로 매칭하지만,
        //   엑셀에 표시되는 값은 '수당계산일'이 아니라 실제 '지급일'(= 캘린더 날짜)이어야 한다.
        const payLabel = (this.payoutDate === td ? (this.payoutDate + ' (오늘)') : this.payoutDate);
        const rows = data.map(r => ({
          지급일: payLabel,
          은행명: r.bankName || '',
          계좌번호: r.accountNo || '',
          지급금액: r.payAmt,
          로그인id: r.loginId,
          이름: r.name,
          입금자: '케이노마드'
        }));
        // 23002: 정렬 스타일 적용 위해 xlsx-js-style 사용
        const ws = XLSXStyle.utils.json_to_sheet(rows, {
          header: ['지급일', '은행명', '계좌번호', '지급금액', '로그인id', '이름', '입금자']
        });
        // 23002: 열너비 지정
        ws['!cols'] = [{ wch: 22 }, { wch: 15 }, { wch: 19 }, { wch: 14 }, { wch: 16 }, { wch: 18 }, { wch: 14 }];
        // 23002: 정렬 - 지급금액(D) 우측정렬, 나머지 중앙정렬. 지급금액 데이터는 천단위 콤마 숫자포맷.
        const cols = ['A', 'B', 'C', 'D', 'E', 'F', 'G'];
        for (let r = 1; r <= rows.length + 1; r++) {   // 1행=헤더, 2행~=데이터
          cols.forEach(col => {
            const cell = ws[col + r];
            if (!cell) return;
            cell.s = cell.s || {};
            cell.s.alignment = { horizontal: (col === 'D' ? 'right' : 'center'), vertical: 'center' };
            cell.s.font = { name: '맑은 고딕' };   // 23002: 엑셀 폰트 맑은 고딕
            if (col === 'D' && r >= 2) cell.z = '#,##0';
          });
        }
        const wb = XLSXStyle.utils.book_new();
        XLSXStyle.utils.book_append_sheet(wb, ws, '수당지급');
        XLSXStyle.writeFile(wb, `payout_${this.payoutDate}.xlsx`);
        this.payoutOpen = false;
      } catch (e) {
        this.payoutError = e.message;
      } finally {
        this.payoutBusy = false;
      }
    }
  }
};
</script>

<style scoped>
.page { background: #fff; padding: 20px; border-radius: 8px; }
h3 { margin: 0 0 16px; }
h4.sub { margin: 18px 0 8px; font-size: 14px; color: #33415c; }
.grid.closing { min-width: 480px; }
.grid .total-row td { font-weight: 700; background: #f7faff; color: #1a5fd0; }
.grid td.center { text-align: center; }
.toolbar { display: flex; gap: 8px; align-items: center; flex-wrap: wrap; margin-bottom: 14px; }
.toolbar label { font-size: 13px; color: #555; }
.toolbar input { padding: 7px 9px; border: 1px solid #d0d5dd; border-radius: 5px; }
.toolbar .spacer { flex: 1; }
.toolbar .dash { color: #888; }
.toolbar button { padding: 7px 16px; background: #2f6fed; color: #fff; border: none; border-radius: 5px; cursor: pointer; }
.toolbar button.ghost { background: #eef1f7; color: #33415c; }
.toolbar button.sm { padding: 6px 10px; font-size: 12px; }
.toolbar input:disabled { background: #f2f4f7; color: #667085; }
/* 20003: 센터/이름 에디트 가로 폭 축소 */
.toolbar input.narrow { width: 96px; }
.table-scroll { overflow-x: auto; }
.grid { width: 100%; border-collapse: collapse; min-width: 1300px; }
.grid th, .grid td { border: 1px solid #e5e8ef; padding: 8px 10px; font-size: 13px; white-space: nowrap; }
.grid th { background: #f0f3fa; color: #33415c; }
.grid td.num { text-align: right; }
.grid td.total-cell { font-weight: 700; color: #1a5fd0; background: #f7faff; }
.rank { display: inline-block; padding: 2px 8px; background: #eef3ff; color: #2f6fed; border-radius: 10px; font-size: 12px; }
.empty { text-align: center; color: #999; padding: 20px; }
.modal-mask { position: fixed; inset: 0; background: rgba(0,0,0,.4); display: flex; align-items: center; justify-content: center; z-index: 50; }
.modal { background: #fff; padding: 22px; border-radius: 8px; width: 380px; max-width: 92vw; }
.modal h4 { margin: 0 0 14px; }
.dl-row { display: flex; align-items: center; gap: 10px; margin: 10px 0; }
.dl-row label { width: 56px; font-size: 13px; color: #555; }
.dl-row input { flex: 1; padding: 8px; border: 1px solid #d0d5dd; border-radius: 6px; }
.dl-error { color: #d93636; font-size: 13px; }
/* 스펙56: 반품PV/반품철회PV 발생근거 */
.pv-cell { white-space: nowrap; }
.basis-btn {
  margin-left: 6px; border: 1px solid #4d8bff; background: #eef4ff; color: #2f5fd0;
  border-radius: 5px; padding: 1px 7px; font-size: 11px; cursor: pointer; vertical-align: middle;
}
.basis-btn:hover { background: #dce8ff; }
.basis-modal { width: min(1050px, 96vw); padding: 18px 20px; }
.basis-head { display: flex; align-items: center; justify-content: space-between; margin-bottom: 10px; }
.basis-head h4 { margin: 0; font-size: 16px; color: #1f2a44; }
.basis-pv { display: flex; flex-direction: column; gap: 6px; font-size: 14px; color: #1f2a44; margin-bottom: 8px; }
.basis-pv .num { font-weight: 700; }
.basis-pv .basis-range { color: #55617a; font-size: 12.5px; font-weight: 400; }
.basis-note { font-size: 12.5px; color: #55617a; background: #f5f8fd; border: 1px solid #e4ecf7; border-radius: 6px; padding: 8px 10px; margin: 4px 0 12px; line-height: 1.5; }
.basis-table-wrap { max-height: 46vh; overflow: auto; }
.basis-grid { width: 100%; }
.basis-grid th, .basis-grid td { font-size: 12px; padding: 5px 6px; }
.dl-block-msg { color: #d93636; font-size: 13px; margin: 0 0 12px; }
.modal-btns { display: flex; justify-content: flex-end; gap: 8px; margin-top: 14px; }
.modal-btns button { padding: 8px 16px; border-radius: 6px; cursor: pointer; border: 1px solid #ccc; }
.modal-btns .primary { background: #2f6fed; color: #fff; border-color: #2f6fed; }
.modal-btns .ghost { background: #f5f5f5; }
</style>
